import { APPLY_NOW_PATH } from "../utils/appLinks";

// Mirrors the brand's workflow steps configured in the CRM, in the same order.
// Update this list if the CRM workflow changes.
const stages = [
  {
    title: "Get Started",
    steps: [
      { title: "Basic Details & Mobile OTP", desc: "Share your employment type, salary, email, mobile and PAN, then verify the OTP." },
      { title: "Location Access", desc: "Allow location access on your device." },
    ],
  },
  {
    title: "Verify Your Identity",
    steps: [
      { title: "PAN Verification", desc: "We confirm your PAN details." },
      { title: "Eligibility Check", desc: "An automatic assessment. There is nothing for you to fill in." },
      { title: "Aadhaar Verification", desc: "Complete your Aadhaar KYC digitally." },
      { title: "Live Photo", desc: "Take a live photo using your device camera." },
    ],
  },
  {
    title: "Confirm Your Finances",
    steps: [
      { title: "Income Proof", desc: "Share your bank statement or connect through Account Aggregator." },
      { title: "Bank Verification", desc: "Add the bank account you want the loan paid into." },
      { title: "Employment Details", desc: "Tell us about your company and role." },
      { title: "Alternate Number", desc: "Add an alternate contact number." },
    ],
  },
  {
    title: "Review & Submit",
    steps: [
      { title: "Loan Application", desc: "Review your loan details and submit your application." },
    ],
  },
];

export const TOTAL_APPLICATION_STEPS = stages.reduce((total, stage) => total + stage.steps.length, 0);

export const ApplicationJourneySection = ({
  ctaHref = APPLY_NOW_PATH,
  ctaLabel = "APPLY NOW",
}: {
  ctaHref?: string;
  ctaLabel?: string;
}) => {
  let stepNumber = 0;

  return (
    <section className="py-15 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-10 lg:mb-14">
          <span className="text-[#CC1A1A] text-xs font-black tracking-[0.3em] uppercase mb-3">
            YOUR APPLICATION JOURNEY
          </span>
          <div className="w-8 h-0.5 bg-[#CC1A1A] mb-5" />
          <h2 className="text-4xl xl:text-5xl font-bold text-[#1a1a4e] mb-4">
            {TOTAL_APPLICATION_STEPS} Steps, {stages.length} Stages
          </h2>
          <p className="text-gray-400 font-light text-base max-w-2xl">
            The application form has {TOTAL_APPLICATION_STEPS} steps. Here is exactly what happens at each
            one, from your first details to your submitted application.
          </p>
        </div>

        {/* Funnel stages */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {stages.map((stage, stageIndex) => (
            <div key={stage.title} className="rounded-2xl border border-[#f6bdbd] p-6 flex flex-col gap-4">
              <div>
                <span className="text-[#CC1A1A] text-xs font-black tracking-[0.2em] uppercase">
                  Stage {stageIndex + 1}
                </span>
                <h3 className="text-[#1a1a4e] font-bold text-lg mt-1">{stage.title}</h3>
              </div>
              <ol className="flex flex-col gap-4">
                {stage.steps.map((step) => {
                  stepNumber += 1;
                  return (
                    <li key={step.title} className="flex items-start gap-3">
                      <span className="w-7 h-7 rounded-full bg-[#CC1A1A] text-white text-xs font-bold flex items-center justify-center flex-shrink-0">
                        {stepNumber}
                      </span>
                      <div>
                        <p className="text-[#121215] font-semibold text-sm">{step.title}</p>
                        <p className="text-gray-500 text-sm leading-relaxed">{step.desc}</p>
                      </div>
                    </li>
                  );
                })}
              </ol>
            </div>
          ))}
        </div>

        <p className="text-gray-500 text-sm text-center mt-6">
          After you submit, your application is reviewed. If it is approved, your sanction letter is sent to
          your email and the loan amount is paid into your verified bank account.
        </p>

        <div className="flex justify-center mt-8">
          <a
            href={ctaHref}
            className="px-8 py-3.5 bg-[#CC1A1A] text-white text-sm tracking-widest uppercase hover:bg-red-800 transition-colors rounded text-center"
          >
            {ctaLabel}
          </a>
        </div>
      </div>
    </section>
  );
};
